import { GET_STATES } from "../types/stateType";

const initialState = {
    countryStates: []
};

const stateReducer = (state = initialState, action) => {
    const { payload, type } = action;
    switch (type) {
        case GET_STATES:
            return {
                ...state,
                countryStates: payload
            };
        default:
            return state;
    }
};

export default stateReducer;
